import { connect } from 'react-redux';
import React, { useEffect, useState, useRef } from 'react';
import { Col, Divider, Row, message } from 'antd';
import { StyledDescriptions } from '../../../CSS/style';
import ReactEcharts from '../../../../Dashboard/ChartComponents/Echarts/Echarts';
import {
  getDeviceList,
  // submitWorkOrder,
  // getLocationByAsset,
  getOverview
} from '../../../Utils/FormCalls';

const EquipmentOverviewDetails = (props) => {
  const EquipmentOverViewRef = useRef();
  const [, setDeviceList] = useState([]);
  const [formObject, setFormObject] = useState(
    props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {}
  );
  const [data, setData] = useState({});
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [option] = useState({
    label: {
      color: 'white',
      fontWeight: 'bold'
    },
    textStyle: {
      color: 'white',
      fontWeight: 'bold'
    },
    legend: {
      left: 'center',
      textStyle: {
        color: 'white'
      },
      data: []
    },
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: '50%',
        data: [
          { value: 1048, name: 'No Of Materials Used' },
          { value: 735, name: 'No Of Parts Replaced' },
          { value: 580, name: 'No Of Downtimes' },
          { value: 484, name: 'No Of Inspections' }
        ]
      }
    ]
  });
  const [optionBar] = useState({
    legend: {
      textStyle: { color: 'white' }
    },
    tooltip: {},
    dataset: {
      dimensions: [
        'product',
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      source: [
        {
          product: 'No Of Inspections',
          January: 43.3,
          February: 85.8,
          March: 93.7,
          April: 21.7,
          May: 76.4,
          June: 32.9,
          July: 54,
          August: 92,
          September: 39,
          October: 84,
          November: 72,
          December: 53
        },
        {
          product: 'No Of Downtimes',
          January: 83.1,
          February: 73.4,
          March: 55.1,
          April: 21.7,
          May: 76.4,
          June: 32.9,
          July: 54,
          August: 92,
          September: 39,
          October: 84,
          November: 72,
          December: 53
        },
        {
          product: 'No Of Repairs',
          January: 86.4,
          February: 65.2,
          March: 82.5,
          April: 21.7,
          May: 76.4,
          June: 32.9,
          July: 54,
          August: 92,
          September: 39,
          October: 84,
          November: 72,
          December: 53
        },
        {
          product: 'No Of Materials Used',
          January: 72.4,
          February: 53.9,
          March: 39.1,
          April: 21.7,
          May: 76.4,
          June: 32.9,
          July: 54,
          August: 92,
          September: 39,
          October: 84,
          November: 72,
          December: 53
        }
      ]
    },
    xAxis: {
      type: 'category',
      axisLine: {
        lineStyle: {
          color: 'white'
        }
      },
      axisTick: {
        lineStyle: {
          color: 'white'
        }
      },
      axisLabel: {
        color: 'white'
      }
    },
    yAxis: {
      axisLine: {
        lineStyle: {
          color: 'white'
        }
      },
      axisTick: {
        lineStyle: {
          color: 'white'
        }
      },
      axisLabel: {
        color: 'white'
      }
    },
    series: [
      { type: 'bar' },
      { type: 'bar' },
      { type: 'bar' },
      { type: 'bar' },
      { type: 'bar' },
      { type: 'bar' },
      { type: 'bar' },
      { type: 'bar' },
      { type: 'bar' },
      { type: 'bar' },
      { type: 'bar' },
      { type: 'bar' }
    ]
  });

  
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        let deviceList = await getDeviceList();
        setDeviceList(deviceList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      getOverviewDetails();
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      EquipmentOverViewRef.current.setFieldsValue(props.formObject);
    }
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
    }
  }, [props]);

  const getOverviewDetails = async () => {
    let pathname = props.location.pathname;
    let tmp = pathname.slice(pathname.lastIndexOf('/') + 1);
    let data = await getOverview(tmp);
    setData(data);
  };

  // const handleChange = async (value, key) => {
  //   let updatedFormObject = {
  //     ...formObject,
  //     [key]: value
  //   };
  //   if (key === 'DeviceId') {
  //     let selectedDevice = deviceList.filter((item) => item.Id === value);
  //     let location = await getLocationByAsset(selectedDevice[0]);
  //     updatedFormObject = {
  //       ...updatedFormObject,
  //       LocationId: location.data.Name
  //     };
  //   }

  //   EquipmentOverViewRef.current.setFieldsValue(updatedFormObject);
  //   setFormObject(updatedFormObject);
  // };

  // const onFormsubmit = async () => {
  //   let statusResponse = await submitWorkOrder(formObject);
  //   if (statusResponse && statusResponse.message) {
  //     getOverviewDetails();
  //     message.success('WorkOrder Submitted Successfully');
  //     onReset();
  //   } else if (statusResponse && statusResponse.Error) {
  //     message.error(statusResponse.Error);
  //   }
  // };

  const onReset = () => {
    EquipmentOverViewRef.current.resetFields();
  };

  return (
    <>
      <div>
        <StyledDescriptions style={{ color: 'white' }} layout="vertical">
          <StyledDescriptions.Item label="Equipment">{data.Equipment}</StyledDescriptions.Item>
          <StyledDescriptions.Item label="Equipment Description">
            {data.EquipmentDescription}
          </StyledDescriptions.Item>
          <StyledDescriptions.Item label="Installation Date">
            {data.InstallationDate}
          </StyledDescriptions.Item>
          <StyledDescriptions.Item label="Equipment Capacity">
            {data.Capacity}
          </StyledDescriptions.Item>
          <StyledDescriptions.Item label="No Of WOs Created">
            {data.WorkOrdersCount}
          </StyledDescriptions.Item>
          <StyledDescriptions.Item label="Run Hours">{data.RunHours}</StyledDescriptions.Item>
          <StyledDescriptions.Item label="OEE">{data.OEECount}</StyledDescriptions.Item>
          <StyledDescriptions.Item label="No Of Parts Replaced">
            {data.PartsCount}
          </StyledDescriptions.Item>
          <StyledDescriptions.Item label="No Of Inspections">
            {data.InspectionCount}
          </StyledDescriptions.Item>
          <StyledDescriptions.Item label="No Of Maintainece">
            {data.MaintaineceCount}
          </StyledDescriptions.Item>
          <StyledDescriptions.Item label="No Of Materials Used">
            {data.MaterialsCount}
          </StyledDescriptions.Item>
          <StyledDescriptions.Item label="Total No of Downtimes">
            {data.TotalDownTime}
          </StyledDescriptions.Item>
          <StyledDescriptions.Item label="Most Recent Inspection">
            {data.InspectionDate}
          </StyledDescriptions.Item>
          <StyledDescriptions.Item label="Most Recent Downtime">
            {data.DownTimeDate}
          </StyledDescriptions.Item>
          <StyledDescriptions.Item label="Most Recent Repair">
            {data.RepairDate}
          </StyledDescriptions.Item>
        </StyledDescriptions>
      </div>
      <Divider />
      <Row gutter={[16, 16]}>
        <Col span={7}>
          <ReactEcharts option={option} className="react_for_echarts" />
        </Col>
        <Col span={11}>
          <ReactEcharts option={optionBar} className="react_for_echarts" />
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(EquipmentOverviewDetails);